import { TranslocoPipe } from '@jsverse/transloco';
import { Component } from '@angular/core';
import { RevealDirective } from '../../../shared/animations/reveal.directive';
import { UltimatePlayerCardComponent } from '../../stats/components/ultimate-player-card.component';
import { DEMO_CARD_GIACOMO, DEMO_CARD_PAUL } from '../domain/landing-demo-data';

@Component({
  selector: 'app-landing-team-cards',
  standalone: true,
  imports: [TranslocoPipe, RevealDirective, UltimatePlayerCardComponent],
  template: `
    <section class="team-cards" aria-labelledby="team-cards-title">
      <div class="section-heading" appReveal>
        <span>{{ 'landing.yourStats' | transloco }}</span>
        <h2 id="team-cards-title">{{ 'landing.yourUltimatePlayerCardWorthSharing' | transloco }}</h2>
        <p>{{ 'landing.rgxRealPerformanceAndAchievementsFromBasicToPro' | transloco }}</p>
      </div>

      <div class="cards-grid">
        <app-ultimate-player-card
          appReveal
          [appRevealIndex]="1"
          [displayName]="paul.displayName"
          [avatarUrl]="paul.avatarUrl"
          [rgxValue]="paul.rgx"
          [stats]="paul.stats"
          [pinnedBadges]="paul.badges"
        />
        <app-ultimate-player-card
          appReveal
          [appRevealIndex]="2"
          [displayName]="giacomo.displayName"
          [avatarUrl]="giacomo.avatarUrl"
          [rgxValue]="giacomo.rgx"
          [stats]="giacomo.stats"
          [pinnedBadges]="giacomo.badges"
        />
      </div>
    </section>
  `,
  styles: [`
    .team-cards {
      display: grid;
      gap: var(--space-6);
      margin-inline: auto;
      width: min(100%, 74rem);
    }

    .section-heading {
      display: grid;
      gap: var(--space-2);
      max-width: 44rem;
    }

    .section-heading span {
      color: var(--color-primary);
      font-size: var(--font-size-label);
      font-weight: 900;
      text-transform: uppercase;
    }

    h2, p { margin: 0; }

    h2 {
      font-size: clamp(1.75rem, 4vw, 3.2rem);
      letter-spacing: 0;
      line-height: 1.05;
    }

    .section-heading p {
      color: var(--color-text-secondary);
      line-height: 1.7;
    }

    .cards-grid {
      display: grid;
      gap: clamp(1rem, 3vw, 2rem);
      grid-template-columns: repeat(2, minmax(0, 24rem));
      justify-content: center;
    }

    @media (max-width: 900px) {
      .cards-grid {
        grid-template-columns: minmax(0, 24rem);
      }
    }
  `],
})
export class LandingTeamCardsComponent {
  readonly paul = DEMO_CARD_PAUL;
  readonly giacomo = DEMO_CARD_GIACOMO;
}
